"use client";

import RouteErrorPanel from "@/app/components/errors/RouteErrorPanel";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <html lang="en" dir="ltr">
      <body style={{ margin: 0, backgroundColor: "#020813" }}>
        <RouteErrorPanel error={error} reset={reset} source="global-error-boundary" />
      </body>
    </html>
  );
}
